<template>
  <div v-if="ifContratR2" class="file-section file-section-form file-section--active">
    <div class="file-section-content">
      <div>
        <div class="file-circle file-circle--active"/>
      </div>
      <div class="file-section-content-label">Formulaire de candidature</div>
    </div>
  </div>
  <div v-else-if="statut =='Abouti'" class="file-section file-section-form file-section--active file-section--pointer" @click="toCandidacy">
    <div class="file-section-content">
      <div>
        <div class="file-circle file-circle--active"/>
      </div>
      <div class="file-section-content-label">Formulaire de candidature</div>
      <div>
        <div class="file-icon file-icon--active"><img src="@/assets/img/file/eye.png"></div>
      </div>
    </div>
  </div>
  <div v-else-if="ifCandidature" class="file-section file-section-form file-section--active file-section--pointer" @click="toCandidacy">
    <div class="file-section-content">
      <div>
        <div class="file-circle file-circle--active"/>
      </div>
      <div class="file-section-content-label">Formulaire de candidature</div>
      <div>
        <div class="file-icon file-icon--active"><img class="penIcon" src="@/assets/img/file/pen.png"></div>
      </div>
    </div>
  </div>
  <div v-else class="file-section file-section-form file-section--active file-section--pointer" @click="toCandidacy">
    <div class="file-section-content">
      <div>
        <div class="file-circle file-circle--active"/>
      </div>
      <div class="file-section-content-label">Formulaire de candidature</div>
      <div>
        <div class="file-icon file-icon--active"><img class="padlock-openIcon" src="@/assets/img/file/padlock-open.png"></div>
      </div>
    </div>
  </div>
</template>

<script>
import RouteEnum from "@/router/RouteEnum";

export default {
  name: "FileForm",
  props: {
    ifCandidature: Boolean,
    statut: String,
    ifContratR2: Boolean
  },
  methods: {
    toCandidacy: function () {
      this.$router.push({name: RouteEnum.CANDIDACY_INFO_PERSONAL});
    }
  }
};
</script>
